var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMobileApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#525254",
  fillRule: "evenodd",
  d: "M17.3 6A2.7 2.7 0 0 1 20 8.7v6.6a2.7 2.7 0 0 1-2.7 2.7h-2.6a2.7 2.7 0 0 1-2.7-2.7V8.7A2.7 2.7 0 0 1 14.7 6zM17 2a1 1 0 0 1 0 2H2.7a.7.7 0 0 0-.7.7v9.6a.7.7 0 0 0 .7.7H9a1 1 0 0 1 0 2H2.7A2.7 2.7 0 0 1 0 14.3V4.7A2.7 2.7 0 0 1 2.7 2zm.3 6h-2.6a.7.7 0 0 0-.7.7v6.6a.7.7 0 0 0 .7.7h2.6a.7.7 0 0 0 .7-.7V8.7a.7.7 0 0 0-.7-.7"
})));
export default SvgIconMobileApp;